import styled from "styled-components";
import { Anchor } from "discover.medical.react-component-library";

export const StyledLink = styled(Anchor)`
  &:hover * {
    text-decoration: underline;
  }
`;
